var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0163 14.7412C11.0163 14.922 10.933 15.0053 10.7246 15.0053H9.26464C9.07047 15.0053 8.9863 14.922 8.9863 14.7412V13.2953C8.9863 13.1145 9.07047 13.0303 9.26464 13.0303H10.7246C10.933 13.0303 11.0163 13.1145 11.0163 13.2953V14.7412ZM9.3338 4.99449H10.6688C10.863 4.99449 10.933 5.07783 10.933 5.24449L10.7388 11.5295C10.7388 11.6678 10.6838 11.7095 10.5305 11.7095H9.5013C9.34797 11.7095 9.29297 11.6678 9.29297 11.5295L9.07047 5.24449C9.07047 5.07783 9.13964 4.99449 9.3338 4.99449ZM10.0013 1.66699C5.40714 1.66699 1.66797 5.40449 1.66797 10.0003C1.66797 14.5945 5.40714 18.3337 10.0013 18.3337C14.5963 18.3337 18.3346 14.5945 18.3346 10.0003C18.3346 5.40449 14.5963 1.66699 10.0013 1.66699Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.db1c56473e63763d3cd78e86d32cd984.svg";
export { ForwardRef as ReactComponent };